module.exports = __webpack_public_path__ + "img/Gaming-01.cb7a3411.png";